import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Typography
} from '@mui/material';
import { useTranslation } from '../i18n/i18n';

export default function RejectTimecardDialog({ open, onClose, onConfirm }) {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');
  const [error, setError] = useState(false);

  const handleConfirm = () => {
    if (!reason.trim()) {
      setError(true);
      return;
    }
    onConfirm(reason);
    setReason('');
    setError(false);
  };

  const handleClose = () => {
    setReason('');
    setError(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{t('calendar_supervisor_rejection_dialog')}</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>{t('calendar_supervisor_rejection_prompt')}</Typography>
        <TextField
          multiline
          rows={3}
          fullWidth
          value={reason}
          onChange={(e) => { setReason(e.target.value); setError(false); }}
          error={error}
          helperText={error ? t('calendar_rejection_required') : ''}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t('cancel') || 'Cancel'}</Button>
        <Button variant="contained" color="error" onClick={handleConfirm}>
          {t('calendar_supervisor_reject')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
